<template>
  <Authenticated>
    <h1>Manage {{ site }} menus</h1>
    <div class="spacer"></div>
    <div class="tab-buttons">
      <button class="tab-btn" data-tab="products" @click="showProductTab">Categories</button>
      <button class="tab-btn" data-tab="modifiers" @click="showModifierTab">Modifiers</button>
    </div>
    <section class="tab-container">
      <section v-if="modifierTab" class="tab">
        <div class="section">
          <div tabindex="0" v-for="(modifierset, idx) in modifierSets" :key="modifierset + idx" class="product-grid-container">
            <div class="bin">
              <h3 class="bin-header">
                {{ modifierset.value.name }}
                <font-awesome-icon icon="trash" @click.stop.prevent="check(idx, modifierset, 'modifier')" size="lg" />
                <span :class="`warning${idx}`" class="warn">{{ warning }}</span>
              </h3>
              <span class="rules">
                <p>Inventory</p>
                <ToggleSwitch
                  :modelName="modifierset.value.name + 'inventory'"
                  :modelValue="modifierset.value.rules.inventory"
                  @update:modelValue="saveMod($event, modifierset, 'inventory')" />
              </span>
              <span class="rules">
                <p>Limit one</p>
                <ToggleSwitch
                  :modelName="modifierset.value.name + 'limit'"
                  v-model="modifierset.value.rules.oneonly"
                  @update:modelValue="saveMod($event, modifierset, 'oneonly')" />
              </span>
              <span class="rules">
                <p>Required</p>
                <ToggleSwitch
                  :modelName="modifierset.value.name + 'required'"
                  v-model="modifierset.value.rules.required"
                  @update:modelValue="saveMod($event, modifierset, 'required')" />
              </span>
            </div>
            <div class="product-grid">
              <div
                :tabindex="idx"
                v-for="(modifier, idx) in modifierset.value.modifiers"
                :key="modifier"
                class="product"
                @click.stop.prevent="openModifierModal(modifier, modifierset)">
                <p>{{ modifier.name }}</p>
              </div>
              <div class="product" @click.stop.prevent="openModifierModal('addNew', modifierset)">
                <span><font-awesome-icon class="exit" icon="fa-plus" size="lg" />Modifier</span>
              </div>
            </div>
          </div>
          <div class="product add-new" @click.stop.prevent="add('modifierSet')">
            <span><font-awesome-icon class="exit" icon="fa-plus" size="lg" />Modifier Set</span>
          </div>
        </div>
      </section>
      <section v-if="productTab" class="tab">
        <div class="section">
          <div v-for="(category, idx) in POSCategories(site)" :key="category" class="product-grid-container">
            <h3 class="bin-header">
              {{ category.value.name }}
              <font-awesome-icon icon="trash" @click.stop.prevent="check(idx, category, 'category')" size="lg" />
              <span :class="`warning${idx}`" class="warn">{{ warning }}</span>
            </h3>
            <div class="product-grid">
              <div tabindex="0" v-for="product in category.value.products" :key="product" class="product" @click.stop.prevent="openModal(product, category.value.name)">
                <p class="none">
                  {{ (prod = POSProductLookup({ site: site, prod: product })) }}
                </p>
                <p v-if="prod">{{ prod.value.name }}</p>
                <CurrencyFormatter :value="prod.value.price" :currency="companySettings.currency" />
              </div>
              <div class="product" @click.stop.prevent="openModal('addNew', category.value.name)">
                <span><font-awesome-icon class="exit" icon="fa-plus" size="lg" />Product</span>
              </div>
            </div>
          </div>
          <div class="product add-new" @click.stop.prevent="add('category')">
            <span><font-awesome-icon class="exit" icon="fa-plus" size="lg" />Category</span>
          </div>
        </div>
      </section>
    </section>
    <section v-if="newModSet || newCategory" class="check-container">
      <div class="check-content">
        <div class="set-name">
          <div v-if="labelInput.value == 'mod'">
            <label for="name"
              ><h3>{{ labelInput.label }}:</h3></label
            >
            <input type="text" v-model="newModSetName" />
            <div class="btns">
              <button @click.stop.prevent="addNewModifierSet">Create</button>
              <button @click.stop.prevent="newModSet = !newModSet">Cancel</button>
            </div>
          </div>
          <div v-if="labelInput.value == 'cat'">
            <label for="name"
              ><h3>{{ labelInput.label }}:</h3></label
            >
            <input type="text" v-model="newCategoryName" />
            <div class="btns">
              <button @click.stop.prevent="addCategory">Create</button>
              <button @click.stop.prevent="newCategory = !newCategory">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="deleteCheck" class="check-container">
      <div class="check-content">
        <h3>Are you sure you want to delete this {{ type }}?</h3>
        <div class="btns">
          <button @click.stop.prevent="confirmDelete(type)">Delete</button>
          <button @click.stop.prevent="deleteCheck = !deleteCheck">Cancel</button>
        </div>
      </div>
    </section>
    <ModifierModal
      :modifier="selectedModifier"
      :modifierset="currentModSet"
      :open="showModifierModal"
      @close-modal="closingModal"
      @commit="saveModifier"
      @remove="removeModifier" />
    <ProductModal :product="product.value" :open="showModal" :modifierSets="getModifierSets(site)" @save="saveProduct" @remove="removeProduct" @close-modal="closingModal" />
  </Authenticated>
</template>

<script>
import { mapGetters } from "vuex";
import Authenticated from "../_layouts/Authenticated.vue";
import { ProductModal, ModifierModal, ToggleSwitch, CurrencyFormatter } from "@monolith/components";
import { api } from "@monolith/helpers";
import Slug from "slug";

export default {
  name: "SiteMenu",
  components: { ProductModal, ModifierModal, ToggleSwitch, Authenticated, CurrencyFormatter },

  data() {
    return {
      site: this.$route.params.site,
      modifierTab: false,
      productTab: true,
      // savedTab: this.$route.params.savedTab,
      tab: "products",
      categories: [],
      product: {},
      showModal: false,
      showModifierModal: false,
      company: localStorage.getItem("company"),
      selectedModifier: {},
      newModSet: false,
      newCategory: false,
      newCategoryName: "",
      newModSetName: "",
      deleteCheck: false,
      current: {},
      currentModSet: {},
      type: "",
      idx: "",
      labelInput: {
        value: "",
        label: "",
      },
      warning: "",
      modifierSets: [],
    };
  },

  async mounted() {
    if (this.savedTab === "modifiers") {
      this.showModifierTab();
      this.tab = "modifiers";
    } else {
      this.showProductTab();
      this.tab = "products";
    }
    // this.modifiersets = await api.getModifierSets(this.company, this.site);
    // this.modifiersets = this.getModifierSets(this.site);

    // Wait a tick to ensure Vuex state is properly initialized
    this.$nextTick(() => {
      this.modifierSets = this.getModifierSets(this.site);
    });
  },

  computed: {
    ...mapGetters({
      POSProducts: "POSProducts",
      POSCategories: "POSCategories",
      POSProductLookup: "POSProductLookup",
      getModifierSets: "getModifierSets",
      companySettings: "companySettings",
    }),

    savedTab() {
      return this.$route.params.tab || "products";
    },
  },
  methods: {
    saveMod(val, mod, rule) {
      mod.value.rules[rule] = val;
      this.save(mod.value);
    },

    save(doc) {
      this.channel.push("document:update", { doc: doc, site: this.site });
    },

    add(type) {
      if (type == "modifierSet") {
        this.labelInput = {
          value: "mod",
          label: "Modifier Set Name",
        };
        this.newModSet = true;
        return;
      }
      if (type == "category") {
        this.labelInput = {
          value: "cat",
          label: "Category Name",
        };
        this.newCategory = true;
        return;
      }
    },

    async removeCategory() {
      await this.channel.push("document:delete", {
        site: this.site,
        doc: this.current.key._id,
        rev: this.current.key._rev,
      });
    },

    async addCategory() {
      let cat = {
        _id: "category:" + Slug(this.newCategoryName),
        name: this.newCategoryName,
        description: "",
        posOnly: false,
        products: [],
      };
      this.newCategory = false;
      await this.channel.push("document:new", { doc: cat, site: this.site });
    },

    removeModifier() {
      let modIndex = this.currentModSet.value.modifiers.findIndex((m) => m.name == this.selectedModifier.name);
      this.currentModSet.value.modifiers.splice(modIndex, 1);
      this.channel.push("document:update", { doc: this.currentModSet.value, site: this.site });
      this.showModifierModal = !this.showModifierModal;
      this.$router.go(-1);
    },

    //not saving new modifiers
    async saveModifier(editedModifier) {
      let found = false;
      if (this.currentModSet.value.modifiers.length == 0) {
        this.currentModSet.value.modifiers.push(editedModifier);
      } else {
        this.currentModSet.value.modifiers.forEach((mod) => {
          if (mod.name == editedModifier.name) {
            mod = editedModifier;
            found = true;
          }
        });
        if (!found) {
          this.currentModSet.value.modifiers.push(editedModifier);
        }
      }
      await this.channel.push("document:update", { site: this.site, doc: this.currentModSet.value });
      this.showModifierModal = !this.showModifierModal;
      this.$router.go(-1);
    },

    check(idx, current, type) {
      if ((type == "category" && current.value.products.length == 0) || (type == "modifier" && current.value.modifiers.length == 0)) {
        this.type = type;
        this.idx = idx;
        this.current = current;
        this.deleteCheck = true;
        return;
      } else {
        let prodsOrMods = type == "category" ? "products" : "modifiers";
        let el = document.querySelector(".warning" + idx);
        el.classList.add("warning");
        el.classList.remove("warn");
        this.warning = `${current.value.name} has ${prodsOrMods} in it, please remove them before deleting.`;
        this.deleteCheck = false;
      }
    },

    confirmDelete(type) {
      if (type == "modifier") {
        this.removeModifierSet();
      }
      // this.confirmDelete = false;
      if (type == "category") {
        this.removeCategory();
      }
    },

    async removeModifierSet() {
      await this.channel.push("document:delete", {
        site: this.site,
        doc: this.current.value._id,
        rev: this.current.value._rev,
      });
      this.deleteCheck = false;
    },

    async addNewModifierSet() {
      let modSet = {
        _id: "modifierset:" + Slug(this.newModSetName),
        name: this.newModSetName,
        modifiers: [],
        rules: { inventory: false, oneonly: false, required: false },
      };
      this.channel.push("document:new", { site: this.site, doc: modSet });
      // this.modifiersets = await api.getModifierSets(this.company, this.site);
      this.newModSet = false;
    },

    openModifierModal(modifier, modSet) {
      this.$router.push({ params: { site: this.site, tab: this.tab, item: modifier.name ? Slug(modifier.name) : "new-entry" } });
      this.currentModSet = modSet;
      if (modifier == "addNew") {
        this.selectedModifier = {
          active: false,
          desc: "",
          name: "",
          price: 0,
          quantity: 0,
        };
        this.showModifierModal = !this.showModifierModal;
        return;
      } else {
        this.selectedModifier = modifier;
        this.currentModSet = modSet;
        this.showModifierModal = !this.showModifierModal;
      }
    },

    closingModal() {
      this.showModifierModal = false;
      this.showModal = false;
    },

    showModifierTab() {
      this.$router.push({ params: { tab: this.savedTab } });
      this.modifierTab = true;
      this.productTab = false;
      this.tab = "modifiers";

      document.querySelectorAll(".tab-btn").forEach((btn) => {
        btn.classList.remove("active");
      });
      this.$nextTick(() => {
        let mod_btn = document.querySelector('.tab-btn[data-tab="modifiers"]');
        mod_btn.classList.add("active");
      });
    },

    showProductTab() {
      this.$router.push({ params: { tab: this.savedTab } });
      this.productTab = true;
      this.modifierTab = false;
      this.tab = "products";

      document.querySelectorAll(".tab-btn").forEach((btn) => {
        btn.classList.remove("active");
      });
      this.$nextTick(() => {
        let prod_btn = document.querySelector('.tab-btn[data-tab="products"]');
        prod_btn.classList.add("active");
      });
    },

    async removeProduct(product) {
      let prodCat = "category:" + product.category;
      let foundCategory = this.POSCategories(this.site).find((cat) => {
        return cat.id === prodCat ? cat : null;
      });

      var foundProductIndex = foundCategory.value.products.findIndex((p) => {
        let prod = product._id.split(":")[1];
        return p === prod ? p : null;
      });

      if (foundProductIndex != -1) {
        await this.channel.push("document:delete", {
          site: this.site,
          doc: product._id,
          rev: product._rev,
          category: Slug(product.category),
        });
      }
    },

    saveProduct(product) {
      var foundProduct = this.POSProductLookup({
        site: this.site,
        prod: Slug(product.name),
      });
      if (foundProduct) {
        foundProduct = product;
        this.channel.push("document:update", { doc: product, site: this.site });
      } else {
        product._id = "product:" + Slug(product.name);
        product.category = Slug(product.category);
        this.channel.push("document:new", { doc: product, site: this.site });
      }
    },

    openModal(product, category) {
      this.$router.push({ params: { site: this.site, tab: this.tab, item: product } });
      if (product == "addNew") {
        this.product = {
          value: {
            name: null,
            description: null,
            caption: null,
            active: true,
            price: null,
            modifiersets: [],
            images: [],
            soldout: false,
            category: category,
          },
        };
        this.showModal = true;
        return;
      } else {
        this.showModal = true;
        this.product = this.POSProductLookup({
          site: this.site,
          prod: product,
        });
      }
    },
  },

  watch: {
    tab: function (newTab) {
      this.$router.push({
        name: "site-menu-tab",
        params: { site: this.site, tab: newTab },
      });
    },

    getModifierSets: {
      handler() {
        this.modifierSets = this.getModifierSets(this.site);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.none {
  display: none;
}

h1 {
  margin: 1rem;
  text-transform: capitalize;
}

.expand {
  display: none;
}
.warn {
  display: none;
}
.warning {
  display: inline-block;
  color: var(--warning-colour);
  margin: 0.5rem;
}

.details {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  z-index: 100;
  position: relative;
  background-color: var(--tertiary-colour);
  border-radius: 10px;
  box-shadow: var(--box-shadow);
  .blue {
    color: var(--action-colour);
    cursor: pointer;
    margin: 1rem;
  }
}

.check-container {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: var(--background-fade);
}
.check-content {
  position: relative;
  top: 30%;
  left: 30%;
  height: 30vh;
  width: 40vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 1rem;
  z-index: 100;
  border-radius: 10px;
  box-shadow: var(--box-shadow);
  background-color: var(--tertiary-colour);
  .set-name {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 1rem;
    width: 90%;
    input {
      margin: 0.5rem;
      padding: 0.5rem;
      border-radius: 10px;
      border: none;
      box-shadow: var(--box-shadow);
      width: 90%;
    }
    .btns {
      display: flex;
      flex-direction: row;
      button {
        margin: 0.5rem;
        padding: 1rem 2rem;
        border-radius: 10px;
        box-shadow: var(--box-shadow);
        background-color: var(--action-colour);
        color: var(--text-colour);
        border: 1px solid var(--action-colour);
        &:hover {
          cursor: pointer;
          background-color: var(--action-colour);
        }
      }
    }
  }
}

.section {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-y: scroll;
  height: 100%;
  padding: 1rem;
}

h2 {
  margin: 1rem 0.5rem 0.5rem 1rem;
  text-transform: capitalize;
}

svg {
  margin: 0 0.5rem;
  color: var(--action-colour);
  cursor: pointer;
}

.product-grid-container {
  display: flex;
  background-color: var(--tertiary-colour);
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.5rem;
  box-shadow: var(--box-shadow);
  margin: 0.5rem;
  border-radius: 1rem;
  padding: 1rem 0.5rem;
  width: calc(100% - 2rem);
  .bin {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    width: 95%;
    /* margin: 1rem; */
    h3 {
      flex-grow: 1;
    }
    .rules {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 1rem;
      p {
        margin: 0 0.5rem;
      }
    }
  }
}

.bin-header {
  margin: 2rem;
}

.product-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.5rem;
  .flex-head {
    grid-column: 1 / -1;
    margin: 1rem 0.25rem;
  }
}

.add-new {
  margin: 0.5rem;
  background-color: var(--action-colour) !important;
  color: var(--secondary-text-colour);
  svg {
    color: var(--secondary-text-colour);
  }
}
.product {
  height: 5rem;
  width: 10rem;
  border-radius: 5px;
  padding: 0.5rem;
  background-color: var(--primary-colour);
  box-shadow: var(--box-shadow);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  cursor: pointer;
  p {
    margin: 0.25rem;
    color: var(--text-colour);
  }
}

.tab-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-colour);
  border-radius: 20px;
  z-index: 1;
  box-shadow: var(--box-shadow);
  margin: 0 1rem;
  .tab {
    width: 100%;
  }
}

.tab-buttons {
  display: flex;
  flex-direction: row;
  margin: 0 0 0 2rem;
}
.tab-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10rem;
  height: 2.5rem;
  margin: 0.5rem 0 0 0;
  padding: 1rem;
  background-color: var(--primary-colour);
  border: none !important;
  opacity: 0.75;
  color: var(--text-colour);
  border-radius: 10px 10px 0 0;
  text-transform: capitalize;
  transition: color 300ms ease-in-out;
  box-shadow: none;
  transition: all 300ms ease-in-out;
  &:hover {
    cursor: pointer;
    color: var(--action-colour);
  }
}

.tab-btn.active {
  /* z-index: 10; */
  box-shadow: 0px -5px 5px rgb(0, 0, 0, 0.2);
  transform: translate3d(0, 5px, 1px);
  opacity: 1;
}

@media only screen and (orientation: portrait) {
  h3,
  h2 {
    width: 50%;
  }

  .product-grid-container {
    width: calc(100% - 2rem);

    .bin {
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .bin-header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      margin: 0.5rem;
    }
    .product-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      width: 90%;
      margin: 0.5rem;
      gap: 0.5rem;
    }
  }
  .product {
    width: 100%;
    height: 4rem;
    box-sizing: border-box;
    min-width: 0; 
  }

  .spacer {
    height: 4rem;
  }

  .tab-buttons {
    margin: 0 0 0 1.75rem;
  }

  .tab-container {
    margin: 0 0.5rem;
    border-radius: 20px;
  }
}
</style>
